exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-group > .v-select {\n    flex: 1 1 auto;\n    width: 1%;\n}\n.input-group > .v-select > .dropdown-toggle {\n    height: 100%;\n}\n.vdp-datepicker__calendar {\n    position: relative !important;\n}\n", ""]);

// exports
